import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Field } from "formik";

export default function ChargeField({ name, step = 1, disabled = false }) {
  return (
    <Field name={name}>
      {({ field: fieldProps, meta, form }) => {
        const handleDecrement = () => {
          const currentValue = Number(fieldProps.value || 0);
          const newValue = Math.max(0, currentValue - step);
          const roundedValue = Math.round(newValue * 100) / 100;
          form.setFieldValue(name, roundedValue, false);
        };

        const handleIncrement = () => {
          const currentValue = Number(fieldProps.value || 0);
          const newValue = currentValue + step;
          const roundedValue = Math.round(newValue * 100) / 100;
          form.setFieldValue(name, roundedValue, false);
        };

        const hasError = meta.touched && Boolean(meta.error);

        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleDecrement}
                sx={{ minWidth: 40, height: 40 }}
              >
                –
              </Button>
              <TextField
                {...fieldProps}
                disabled={disabled}
                label="Quantity"
                size="small"
                error={hasError}
                helperText=""
                inputProps={{ style: { textAlign: 'center' } }}
                sx={{ 
                  width: 90,
                  '& .MuiInputLabel-root': {
                    left: '50%',
                    top: '50%',
                    transform: 'translateX(-50%) translateY(-50%)',
                    transformOrigin: 'center'
                  },
                  '& .MuiInputLabel-shrink': {
                    left: '50%',
                    top: 0,
                    transform: 'translateX(-50%) translateY(-11px) scale(0.75)',
                    transformOrigin: 'center'
                  },
                  '& .MuiOutlinedInput-notchedOutline legend': {
                    textAlign: 'center'
                  }
                }}
              />
              <Button
                variant="outlined"
                onClick={handleIncrement}
                sx={{ minWidth: 40, height: 40 }}
              >
                +
              </Button>
            </Box>
            {hasError && (
              <Typography
                align="center"
                variant="caption"
                color="error"
                sx={{
                  fontSize: "0.75rem",
                  marginLeft: 1,
                  marginTop: 0.25,
                }}
              >
                {meta.error}
              </Typography>
            )}
          </Box>
        );
      }}
    </Field>
  );
}
